import { useUpdateActualityMutation } from '@warebee/frontend/data-access-api-graphql';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { cloneWithoutTypename } from '../../common/utils';
import { presentationSettingsDocument } from '../../presentationSettings/presentationSettings.state';
import { actualitySelectedId } from '../store/actuality.state';

function useActualityPresentationWatcher() {
  const actualityId = useRecoilValue(actualitySelectedId);
  const [callUpdateActuality] = useUpdateActualityMutation();
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const presentationSettings = useRecoilValue(presentationSettingsDocument);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
    } else {
      callUpdateActuality({
        variables: {
          input: {
            presentationSettings: cloneWithoutTypename(presentationSettings),
            actualityId,
          },
        },
      });
    }
  }, [presentationSettings]);
}

export default useActualityPresentationWatcher;
